// # Returns
// string, e.g. "¥ 1,234"
export const fmtPrice = (price: number): string => priceFormatter.format(price);

const priceFormatter = new Intl.NumberFormat('ja-JP', {
  style: 'currency',
  currency: 'JPY',
});

// # Returns
// string, e.g. "1,234"
export const fmtNum = (num: number): string => numFormatter.format(num);

const numFormatter = new Intl.NumberFormat('ja-JP');

// # Returns
// string, e.g. "1,234円"
export const fmtPriceWithYen = (price: number): string => `${fmtNum(price)}円`;

// # Returns
// string, e.g. "10+"
export const fmtLimitedNum = (num: number, limit: number): string => (num > limit ? `${limit}+` : String(num));
